import { restaurantesSections } from './restaurantesSections';

export const restaurantesManual = {
  id: 'mod-restaurantes',
  title: 'Restaurantes',
  isVisible: (ctx) => ctx.canSeeRestaurantes,
  intro:
    'Pedidos en salón, mesas, cocina, recetas y configuración de cocinas y mesas. Guía completa de operaciones y configuración de restaurantes.',
  sections: restaurantesSections,
};
